import { render, staticRenderFns } from "./BaseMembersCard.vue?vue&type=template&id=3891a968&"
import script from "./BaseMembersCard.vue?vue&type=script&lang=js&"
export * from "./BaseMembersCard.vue?vue&type=script&lang=js&"
import style0 from "./BaseMembersCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports